import React from 'react';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  grid-column-gap: 16px;
  margin-bottom: 16px;
  .header-text {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;
  }
  .breadcrumb {
    font-size: 12px;
    color: #808183;
  }
  h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #16181D;
  }
  .subtitle {
    font-size: 13px;
    color: #4E5969;
  }
  .expiry-badge {
    display: inline-flex;
    align-items: center;
    grid-column-gap: 6px;
    flex-shrink: 0;
    padding: 4px 10px;
    border-radius: 6px;
    background: #FFF4E5;
    color: #8A4B00;
    font-size: 12px;
    font-weight: 600;
    width: fit-content;
  }
`;

// orderName is the work order's own name (workOrderDetails.order_name) — never fabricated,
// left out entirely when not yet loaded rather than showing a placeholder.
const WorkOrderPageHeader = ({ orderName, title, subtitle, expiryLabel }) => (
  <HeaderWrapper>
    <div className='header-text'>
      <div className='breadcrumb'>Work Orders{orderName ? ` / ${orderName}` : ''}</div>
      {title && <h1>{title}</h1>}
      {subtitle && <div className='subtitle'>{subtitle}</div>}
    </div>
    {expiryLabel && <div className='expiry-badge'>{expiryLabel}</div>}
  </HeaderWrapper>
);

export default WorkOrderPageHeader;
